export default __webpack_public_path__ + "static/media/x.2b54b6f0.png";